import { render, staticRenderFns } from "./product.vue?vue&type=template&id=368b7acc&scoped=true"
import script from "./product.vue?vue&type=script&lang=ts"
export * from "./product.vue?vue&type=script&lang=ts"
import style0 from "./product.vue?vue&type=style&index=0&id=368b7acc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368b7acc",
  null
  
)

export default component.exports